import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/imports')({
  staticData: {
    breadcrumb: 'Imports',
    layout: 'default',
  },
  component: () => <Outlet />,
});
